import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isUndefined } from 'lodash';

import styles from './ButtonBlueLarge.module.css';


export  class ButtonBlueLarge extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        glitch: PropTypes.bool,
        gtmTag: PropTypes.string,
        isDisabled: PropTypes.bool,
        onClick: PropTypes.func.isRequired,

        padding: PropTypes.string,
    }

    handleClick = () => {
        if (this.gtmTagRef) {
            this.gtmTagRef.click()
        }
        this.props.onClick()
    }

    renderGtmTag() {
        return !isUndefined(this.props.gtmTag) ? (
            <div className={classNames(this.props.gtmTag)} ref={c => (this.gtmTagRef = c)} />
        ) : null
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isDisabled]: this.props.isDisabled,
            [styles.glitch]: this.props.glitch,
            //[styles.padding]: this.props.padding,
        })
        return (
            <React.Fragment>
                {this.renderGtmTag()}
                <button className={classNameBase} style={{padding: `${this.props.padding}`}} onClick={this.props.isDisabled ? null : this.handleClick}>
                    <span className={styles.content}>{this.props.children}</span>
                </button>
            </React.Fragment>
        )
    }
}
